<div class="brame-card {{ marginClass }}">
    <ng-content></ng-content>
</div>
